import { useCallback } from "react";
import { WheelProps } from "src/components/Wheel/types";
import { GatheringHeaderWheelItemOpacity } from "../constants/GatheringHeaderConstants";
import { GatheringHeaderProps } from "../types";

const useRenderGatheringHeaderWheelItem = <TItem extends any>({
	renderWheelItem,
	wheelDataLoading,
}: Pick<GatheringHeaderProps<TItem>, "renderWheelItem" | "wheelDataLoading">): {
	renderItem: WheelProps<TItem>["renderItem"];
} => {
	const renderItem = useCallback<NonNullable<WheelProps<TItem>["renderItem"]>>(
		({ item, width, height, borderRadius, index }) => {
			if (!item || !renderWheelItem || wheelDataLoading) return null;
			return renderWheelItem({
				item,
				width,
				height,
				opacity: GatheringHeaderWheelItemOpacity,
				borderRadius,
				index,
			});
		},
		[renderWheelItem, wheelDataLoading],
	);

	return {
		renderItem,
	};
};
export default useRenderGatheringHeaderWheelItem;
